import '@babel/polyfill';
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { MediaQueries } from "vue-media-queries";
import SocialSharing from "vue-social-sharing";
import AOS from "aos";
import "aos/dist/aos.css";
Vue.config.productionTip = false;
const mediaQueries = new MediaQueries();


Vue.use(mediaQueries);
Vue.use(SocialSharing);

export const eventBus = new Vue();
new Vue({
  created() {
    AOS.init({
        delay: 100, // values from 0 to 3000, with step 50ms
        duration: 500, // values from 0 to 3000, with step 50ms
    });
  },
  router,
  render: h => h(App),
  mediaQueries: mediaQueries
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js